import {Injectable} from '@angular/core';
import {CrudService, RequestParams} from '@ngx-ivengi/crud';
import {Throughput} from './throughput.model';

@Injectable()
export class ThroughputService extends CrudService<Throughput> {
  public entityType = Throughput;

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/throughput/throughput.service.ts